import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { HCPService } from '../hcp.service';

@Component({
  selector: 'crm-provision-merge-hcp',
  templateUrl: './provision-merge-hcp.component.html',
  styleUrls: ['./provision-merge-hcp.component.css']
})
export class ProvisionMergeHcpComponent implements OnInit {
  error: boolean;
  message: string;
  loading: boolean;
  @ViewChild("provisionMergeModal")
  provisionMergeModal: ModalDirective;
  constructor(private readonly hcpService: HCPService) { }

  ngOnInit() {
  }

  downloadCSVTemplate() {
    this.hcpService.downloadMergeHcpsIntoHcpCSVTemplate().subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "MergeHcpTemplate.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);

    },
      err => { console.log(err); });
  }

  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.loading = true;
    this.error = false;
    this.message = "Loading .....";

    this.hcpService.provisionMergeHcpsIntoHcp(formData).subscribe(result => {
      this.loading = false;
      let res = result as any;
      if (res.isError) {
        this.error = true;
        this.message = "uploaded with error";
        this.downloadMergeHcpsIntoHcpErrorFile(res.errorFile);   // this upload's own error file
      }
      else
        this.message = "uploaded success";
    });

  }

  downloadMergeHcpsIntoHcpErrorFile(file?: string) {
    this.hcpService.downloadMergeHcpsIntoHcpErrorFile(file).subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "HCPMergeError.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);

    },
      err => {
        console.log(err);
      });
  }
}
